export default new class headerNav {
  constructor() {
    this.inputClass = '_user-avatar-upload-input';
    this.formClass = '_user-avatar-upload';
    this.errorClass = '_user-avatar-upload-error';
    this.accountFormClass = '_account-add-form';
    this.accountSubmitClass = '_account-add-submit';
    this.accountSwitchClass = '_account-switch';
    this.accountErrorClass = '_account-switcher-error';

    this.init();
  }

  init() {
    this.initAvatarUpload();
    this.initAccountSwitcher();
  }

  initAvatarUpload() {
    $(document).on('change', `.${this.inputClass}`, (event) => {
      const input = event.currentTarget;
      const form = input.closest(`.${this.formClass}`);
      const error = form.querySelector(`.${this.errorClass}`);

      if (!input.files.length) return;

      error.textContent = '';
      $(form).request('Settings::onUploadAvatar', {
        files: true,
        complete: ({ responseJSON }) => {
          if (responseJSON && responseJSON.status) {
            window.location.reload();
            return;
          }

          error.textContent = responseJSON && responseJSON.message
            ? responseJSON.message
            : 'Не удалось загрузить аватар';
          input.value = '';
        },
      });
    });
  }

  initAccountSwitcher() {
    $(document).on('submit', `.${this.accountFormClass}`, (event) => {
      event.preventDefault();

      const form = event.currentTarget;
      const submit = form.querySelector(`.${this.accountSubmitClass}`);
      const error = form.querySelector(`.${this.accountErrorClass}`);

      error.textContent = '';
      submit.disabled = true;

      $(form).request('AccountSwitcher::onAddAccount', {
        complete: ({ responseJSON }) => {
          if (responseJSON && responseJSON.status) {
            window.location.reload();
            return;
          }

          error.textContent = responseJSON && responseJSON.message
            ? responseJSON.message
            : 'Не удалось добавить аккаунт';
          submit.disabled = false;
        },
      });
    });

    $(document).on('click', `.${this.accountSwitchClass}`, (event) => {
      event.preventDefault();

      const button = event.currentTarget;
      if (button.disabled) return;

      const accountID = button.dataset.accountId;
      const error = document.querySelector(`.${this.accountErrorClass}`);
      const switchButtonList = document.querySelectorAll(`.${this.accountSwitchClass}`);

      if (error) error.textContent = '';
      switchButtonList.forEach((switchButton) => {
        switchButton.setAttribute('disabled', 'disabled');
      });

      $.request('AccountSwitcher::onSwitchAccount', {
        data: {
          account_id: accountID,
        },
        complete: ({ responseJSON }) => {
          if (responseJSON && responseJSON.status) {
            window.location.reload();
            return;
          }

          if (error) {
            error.textContent = responseJSON && responseJSON.message
              ? responseJSON.message
              : 'Не удалось переключить аккаунт';
          }

          switchButtonList.forEach((switchButton) => {
            if (switchButton.getAttribute('aria-current') === 'true') {
              switchButton.setAttribute('disabled', 'disabled');
            } else {
              switchButton.removeAttribute('disabled');
            }
          });
        },
      });
    });

    $(document).on('hidden.bs.modal', '#account-switcher-modal', (event) => {
      const form = event.currentTarget.querySelector(`.${this.accountFormClass}`);
      if (!form) return;

      form.reset();
      form.querySelector(`.${this.accountErrorClass}`).textContent = '';
      form.querySelector(`.${this.accountSubmitClass}`).disabled = false;
    });
  }
}();
